import React from "react";

export function highlightText(text: string, query: string): React.ReactNode {
	if (!query) return text;

	const normalizedQuery = query.trim().toLowerCase();
	const regex = new RegExp(`(${normalizedQuery})`, "gi");

	const parts = text.split(regex);

	return parts.map((part, i) =>
		part.toLowerCase() === normalizedQuery ? (
			<span key={i} style={{ backgroundColor: "#ffe58a", padding: "0 2px" }}>
				{part}
			</span>
		) : (
			<span key={i}>{part}</span>
		)
	);
}
